// The script-tag bundle: one global `Matreshka` with the router and the form parser attached.
import Matreshka from './index.js';
import { parseForm } from './parse-form/index.js';
import { initRouter, Router } from './router/index.js';
var BundledMatreshka = Matreshka;
BundledMatreshka.initRouter = initRouter;
BundledMatreshka.Router = Router;
BundledMatreshka.parseForm = parseForm;
// the value and the instance type under one name
export { BundledMatreshka as default };